<ng-container>

    <!-- ===========================
        label
    =========================== -->
    @if (showLabel) {
        <label 
            [attr.for]="id"
            class="form-label"
            [ngClass]="labelClassStyle">
    
            @if (getTemplate('label'); as labelTpl) {
                <ng-container *ngTemplateOutlet="labelTpl.templateRef; context: { $implicit: label }" />
            }
            @else {
                {{label}}
            }
            
        </label>
    }

    <!-- ===========================
        select
    =========================== -->
    <select 
        appFormFieldStatus
        class="form-select"
        [ngClass]="classStyleSize"
        [hostControl]="ngControl"
        [ignoreStatus]="ignoreStatus"
        (blur)="onSelectTouched()"
        [ngModelOptions]="ngModelOptions"
        (ngModelChange)="onSelectChange($event)"
        [id]="id"
        [name]="name"
        [ngModel]="value"
        [disabled]="disabled"
        [required]="required"
        [attr.aria-label]="ariaLabel ?? label"
        [attr.aria-describedby]="described ?? label ?? textHelp">
        @for (item of items; track getTrackValue(item, $index)) {
            <option
                [disabled]="item?.disabled"
                [ngValue]="getValueBinding(item)">
                {{getDisplayLabel(item)}}
            </option>
        }
    </select>

    <!-- ===========================
        feedbackType Outlet
    =========================== -->
    @if (touched && (feedbackValidMsg || invalid)) {
        <div [appFormFieldFeedback]="dynamicFeedbackUI" [feedbackProvider]="feedbackProvider">
            <ng-container 
                *ngTemplateOutlet="getTemplate('feedbackMsg')?.templateRef ?? feedbackMsgTpl; context: feedbackContext" />
        </div>
    }

    <!-- ===========================
        TextHelp Outlet
    =========================== -->
    <ng-container 
        *ngTemplateOutlet="getTemplate('textHelp')?.templateRef ?? textHelpTpl; context: { $implicit: textHelp }" />

</ng-container>


<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #textHelpTpl let-textHelp>
  @if (textHelp) {
    <div class="form-text" [ngClass]="textHelpClassStyle">{{textHelp}}</div>
  }
</ng-template>

<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #feedbackMsgTpl let-msg>
  {{msg}}
</ng-template>